$(document).ready(function () {
    // Ensure the first collapsible tab is open on page load
    let firstTabButton = $(".collapsible-trigger").first();
    let firstTabContent = $(".collapsible-content").first();

    // Add 'is-open' class to first tab and its content
    firstTabButton.addClass("is-open").attr("aria-expanded", "true");
    firstTabContent.addClass("is-open").css("height", "auto");
});
